module.exports = __webpack_public_path__ + "img/silver_edge.5c111862.png";